"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorState = exports.STATE_COMPARISION_INTERVAL = exports.SESSION_INTERVAL_RANGE_MINUTES = void 0;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
exports.SESSION_INTERVAL_RANGE_MINUTES = [1, 5, 15, 30];
exports.STATE_COMPARISION_INTERVAL = 1000;
var EditorState = (function () {
    function EditorState($state, telemetry, user) {
        this.telemetry = telemetry;
        this.user = user;
        this.state = $state;
    }
    EditorState.prototype.startEditSession = function () {
        this.editSession = new EditSession(this.internalState, this.telemetry, this.user, this.isMatchingState);
    };
    EditorState.prototype.startSidebarSession = function () {
        this.sidebarSession = new SidebarSession();
    };
    EditorState.prototype.getEditSessionTime = function () {
        if (!this.editSession) {
            this.startEditSession();
            return this.editSession.getEditSessionTime();
        }
        else {
            return this.editSession.getEditSessionTime();
        }
    };
    EditorState.prototype.getSidebarSessionTime = function () {
        var _a;
        if (this.sidebarSession) {
            return (_a = this.sidebarSession) === null || _a === void 0 ? void 0 : _a.getSidebarSessionTime();
        }
        else {
            throw new Error("No sidebar session tracking started before looking up time spent");
        }
    };
    EditorState.prototype.incrementBlockAddedCountInSidebarSession = function () {
        var _a;
        (_a = this.sidebarSession) === null || _a === void 0 ? void 0 : _a.incrementBlockAddedCountInSidebarSession();
    };
    EditorState.prototype.incrementBlockAddedCountInEditSession = function () {
        var _a;
        (_a = this.editSession) === null || _a === void 0 ? void 0 : _a.incrementBlockAddedCountInEditSession();
    };
    EditorState.prototype.getNumBlocksAddedInCurrentSidebarSession = function () {
        if (this.sidebarSession) {
            return this.sidebarSession.getNumBlocksAddedInCurrentSidebarSession();
        }
        else {
            throw new Error("No sidebar session tracking started before looking up number of blocks added");
        }
    };
    EditorState.prototype.getNumBlocksAddedInCurrentEditSession = function () {
        if (this.editSession) {
            return this.editSession.getNumBlocksAddedInCurrentEditSession();
        }
        else {
            throw new Error("No edit session tracking started before looking up number of blocks added");
        }
    };
    EditorState.prototype.getIntervalId = function () {
        return EditSession.intervalId;
    };
    Object.defineProperty(EditorState.prototype, "internalState", {
        get: function () {
            var _a, _b, _c, _d;
            return {
                name: (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.name,
                id: (_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.id,
            };
        },
        enumerable: false,
        configurable: true
    });
    EditorState.prototype.isMatchingState = function (internalAppState) {
        return !(0, isEqual_1.default)(this.internalState, internalAppState);
    };
    return EditorState;
}());
exports.EditorState = EditorState;
var EditSession = (function () {
    function EditSession(internalAppState, telemetry, user, isMatchingState) {
        var _this = this;
        this.internalAppState = internalAppState;
        this.telemetry = telemetry;
        this.user = user;
        this.isMatchingState = isMatchingState;
        this.editSessionStart = new Date();
        this._editSessionDurationRangeIndex = -1;
        this.numBlocksAddedInEditSession = 0;
        if (EditSession.intervalId) {
            this.stopEditSession();
        }
        EditSession.intervalId = window.setInterval(function () {
            _this.projectSessionHeartbeatTick();
        }, exports.STATE_COMPARISION_INTERVAL);
    }
    EditSession.prototype.getEditSessionTime = function () {
        var current = new Date();
        return (current.getTime() - this.editSessionStart.getTime()) / 1000;
    };
    EditSession.prototype.incrementBlockAddedCountInEditSession = function () {
        this.numBlocksAddedInEditSession++;
    };
    EditSession.prototype.getNumBlocksAddedInCurrentEditSession = function () {
        return this.numBlocksAddedInEditSession;
    };
    EditSession.prototype.projectSessionHeartbeatTick = function () {
        if (!this.isMatchingState(this.internalAppState)) {
            this.stopEditSession();
            return;
        }
        var sidebarSessionTimeMinutes = this.getEditSessionTime() / 60;
        if (sidebarSessionTimeMinutes <= exports.SESSION_INTERVAL_RANGE_MINUTES[this._editSessionDurationRangeIndex + 1]) {
            return;
        }
        this._editSessionDurationRangeIndex++;
        if (this._editSessionDurationRangeIndex >= exports.SESSION_INTERVAL_RANGE_MINUTES.length) {
            this.stopEditSession();
            return;
        }
        this.telemetry.trackOnly("Project Edit Session", {
            project_edit_session_edit_session_duration: exports.SESSION_INTERVAL_RANGE_MINUTES[this._editSessionDurationRangeIndex],
            project_edit_session_blocks_added_number: this.numBlocksAddedInEditSession,
            app_sessions_number: this.user.useHistory.sessionCount,
        });
    };
    EditSession.prototype.stopEditSession = function () {
        if (EditSession.intervalId != null) {
            clearInterval(EditSession.intervalId);
            EditSession.intervalId = null;
        }
    };
    EditSession.intervalId = null;
    return EditSession;
}());
var SidebarSession = (function () {
    function SidebarSession() {
        this.numBlocksAddedInSidebarSession = 0;
        this.sidebarSessionStart = new Date();
    }
    SidebarSession.prototype.getSidebarSessionTime = function () {
        var current = new Date();
        return (current.getTime() - this.sidebarSessionStart.getTime()) / 1000;
    };
    SidebarSession.prototype.incrementBlockAddedCountInSidebarSession = function () {
        this.numBlocksAddedInSidebarSession++;
    };
    SidebarSession.prototype.getNumBlocksAddedInCurrentSidebarSession = function () {
        return this.numBlocksAddedInSidebarSession;
    };
    return SidebarSession;
}());
